export default "__VITE_ASSET__Di46YY47__"